<div class="dialog-header">
  <h1 mat-dialog-title class="dialog-title">Bulk Edit Creatives</h1>

  <div class="warning_message">
    Update the fields below for all selected creatives. Only filled fields will be updated.
  </div>
</div>

<div class="tableFixHead resizable-table">
  <table class="dashboard-update" mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef>
        <div class="table-checkboxes">
          <mat-checkbox
            #ref
            (change)="$event ? masterToggle() : null"
            [checked]="
              selection.hasValue() && isAllSelected() && isSomeSelected()
            "
            [indeterminate]="isSomeSelected() && !isAllSelected()"
          >
          </mat-checkbox>
        </div>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        [style.color]="row.color"
        [ngClass]="{ 'greyed-out': row.is_ended }"
      >
        <div class="table-checkboxes">
          <mat-checkbox
            [checked]="selection.isSelected(row)"
            (change)="$event ? selection.toggle(row) : null; isSomeSelected()"
          >
          </mat-checkbox>
        </div>
      </td>
    </ng-container>

    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">ID</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span class="table_value_name">{{ row.id }}</span>
      </td>
    </ng-container>

    <!-- Name Column (Common) -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Name *</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="name-field mt-2 mb-3" appearance="outline" floatLabel="always">
            <mat-label>Name</mat-label>
            <input
              matInput
              type="text"
              autocomplete="off"
              formControlName="name"
              [maxLength]="255"
              placeholder="Enter name"
              (input)="validate()"
            />
            <mat-error *ngIf="editForms[i].hasError('required', 'name')">Name is required</mat-error>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <!-- TDSP: Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Description</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="bulk-edit-field mt-2 mb-3 unset_txt_area_hght" appearance="outline" floatLabel="always">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              formControlName="description"
              [maxlength]="200"
              placeholder="Enter description"
              (input)="validate()"
            ></textarea>
            <mat-hint align="end">
              {{ editForms[i].get('description')?.value?.length || 0 }} / 200
            </mat-hint>
          </mat-form-field>
        </span>
      </td>
    </ng-container> 

    <!-- TDSP: JS Tag Column -->
    <ng-container matColumnDef="js_tag">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">JS Tag</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="tag-field mt-2 mb-3" appearance="outline" floatLabel="always">
            <mat-label>JS Tag</mat-label>
            <input
              matInput
              type="text"
              autocomplete="off"
              formControlName="js_tag"
              placeholder="Enter JS tag"
              (input)="validate()"
            />
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <!-- TDSP: Folder Column -->
    <ng-container matColumnDef="folder">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Folder</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="bulk-edit-field mt-2 mb-3" appearance="outline" floatLabel="always">
            <mat-label>Folder</mat-label>
            <mat-select formControlName="folder" placeholder="Choose One">
              <mat-option *ngFor="let folder of allFolders" [value]="folder.id">
                {{ folder.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <!-- Landing Page URL Column -->
    <ng-container matColumnDef="landing_page_url">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Landing Page URL *</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <ng-container *ngIf="!(dsp === 'bdsp' && row.third_party_tag?.content_tag); else landingPageNA">
          <span [formGroup]="editForms[i]">
          <mat-form-field
            class="landing-page-field mt-2 mb-3"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>Landing Page URL</mat-label>

            <input
              matInput
              required
              type="text"
              autocomplete="off"
              formControlName="landing_page_url"
              placeholder="https://www.example.com"
              (input)="validate()"
            />

            <mat-error *ngIf="editForms[i].hasError('required', 'landing_page_url')">
              Landing page URL is required
            </mat-error>

            <mat-error
              *ngIf="
                editForms[i].hasError('isHTTP', 'landing_page_url') &&
                !editForms[i].hasError('required', 'landing_page_url')
              "
            >
              URL should start with 'https://'
            </mat-error>
          </mat-form-field>

          <button
              *ngIf="i < editForms.length - 1"
              mat-icon-button
              matSuffix
              [matMenuTriggerFor]="copyLandingUrlMenu"
              matTooltip="Copy content"
              type="button"
            >
              <mat-icon>content_copy</mat-icon>
            </button>

          <mat-menu #copyLandingUrlMenu="matMenu">
            <mat-list>
              <mat-list-item
                style="cursor: pointer"
                (click)="copyLandingPageUrl(i, false)"
              >
                <span class="material-icons upload_action me-2">content_copy</span>
                Copy to 1 row below
              </mat-list-item>

              <mat-list-item
                style="cursor: pointer"
                (click)="copyLandingPageUrl(i, true)"
              >
                <span class="material-icons upload_action me-2">content_copy</span>
                Copy to all rows below
              </mat-list-item>
            </mat-list>
          </mat-menu>

          </span>
        </ng-container>
        <ng-template #landingPageNA>
          <span class="text-muted">N/A</span>
        </ng-template>
      </td>
    </ng-container>

    <!-- BDSP: Start Date Column -->
    <ng-container matColumnDef="start_date">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Start Date</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="bulk-edit-field mt-2 mb-3" appearance="outline" floatLabel="always">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              [min]="minDate"
              formControlName="start_date"
              placeholder="dd-mmm-yyyy"
              (dateChange)="validate()"
            />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker [calendarHeaderComponent]="datePickerHeader"></mat-datepicker>
            <mat-error *ngIf="editForms[i].hasError('pastError', 'start_date')" > Start date cannot be in past </mat-error>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <!-- BDSP: End Date Column -->
    <ng-container matColumnDef="end_date">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">End Date</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="bulk-edit-field mt-2 mb-3" appearance="outline" floatLabel="always">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              [min]=" editForms[i].get('start_date')?.value ? editForms[i].get('start_date')?.value > minDate ? editForms[i].get('start_date')?.value : minDate : minDate "
              formControlName="end_date"
              placeholder="dd-mmm-yyyy"
              (dateChange)="validate()"
            />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker [calendarHeaderComponent]="datePickerHeader"></mat-datepicker>
            <mat-error *ngIf="editForms[i].hasError('pastError', 'end_date')" > End date cannot be in past </mat-error>
            <mat-error *ngIf="editForms[i].hasError('endDateBeforeStartDateError', 'end_date')" > End date cannot be before start date </mat-error>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <!-- Third Party Tag Column -->
    <ng-container matColumnDef="third_party_tag">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Third Party Tag
        <span *ngIf="isTdspThirdPartyTagRequired|| isBdspThirdPartyTagRequired">*</span>
        </span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <ng-container *ngIf="dsp === 'tdsp' ? row.third_party_tag : row.third_party_tag?.content_tag; else noTag">
          <span [formGroup]="editForms[i]">
            <mat-form-field
              class="bulk-edit-field bulk-edit-field-wide mt-2 mb-3"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Third Party Tag</mat-label>

              <input
                matInput
                [required]="isTdspThirdPartyTagRequired|| isBdspThirdPartyTagRequired"
                formControlName="third_party_tag"
                placeholder="Enter Third Party Tag"
                rows="4"
                (input)="validate()"
              >

              <mat-error *ngIf="editForms[i].hasError('required', 'third_party_tag')">
                Third Party Tag is required
              </mat-error>
            </mat-form-field>
          </span>
        </ng-container>

        <ng-template #noTag>
          <span class="text-muted">N/A</span>
        </ng-template>
      </td>
    </ng-container>

    <!-- BDSP: Third Party Pixels Column -->
    <ng-container matColumnDef="third_party_pixels">
      <th mat-header-cell *matHeaderCellDef>
        <span class="table_header_name">Third Party Pixels</span>
      </th>
      <td mat-cell *matCellDef="let row; let i = index">
        <span [formGroup]="editForms[i]">
          <mat-form-field class="bulk-edit-field mt-2 mb-3 unset_txt_area_hght bulk-edit-field-wide" appearance="outline" floatLabel="always">
            <mat-label>Third Party Pixels</mat-label>
            <textarea
              matInput
              formControlName="third_party_pixels"
              placeholder="Enter URLs e.g. https://www.example.com (one per line)"
              (input)="validate()"
            ></textarea>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="6">No creatives selected</td>
    </tr>
  </table>
</div>

<div class="align-right genreport-btn mb-2 mt-3">
  <button (click)="closeModal()" mat-button class="action_btn_no-border me-2">
    Cancel
  </button>
  <button
    (click)="deleteItems()"
    mat-button
    [hidden]="selection.selected.length == 0"
    class="create-btn me-2 mb-2"
  >
    Delete
  </button>
  <button
    (click)="save()"
    mat-button
    [disabled]="!isValid || isSaving"
    [ngClass]="{
      'create-btn-disabled': !isValid || isSaving,
      'create-btn': true,
      'me-2 mb-2': true
    }"
  >
    {{ isSaving ? 'Saving...' : 'Save' }}
  </button>
</div>
